import { render, staticRenderFns } from "./MetadataCard.vue?vue&type=template&id=20b7e462&"
import script from "./MetadataCard.vue?vue&type=script&lang=js&"
export * from "./MetadataCard.vue?vue&type=script&lang=js&"
import style0 from "./MetadataCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports